<div> 
    <app-analise-estoque-bi04-filtro
          [filtros]="filtros">
    </app-analise-estoque-bi04-filtro>
    <app-analise-estoque-bi04-lista
          [filtros]="filtros"
          (definirFiltro)="definirFiltro()"
          (exibir)="selecionar($event)">
    </app-analise-estoque-bi04-lista>
   </div>